import { getTrackRouter } from '@inkitt/contracts-common';
import { c } from './contract';
import { authRouter } from './routers/auth.router';
import { checkoutRouter } from './routers/checkout.router';
import { discoveryRouter } from './routers/discovery.router';
import { paymentRouter } from './routers/payment.router';
import { persistRouter } from './routers/persist.router';
import { progressRouter } from './routers/progress.router';
import { readingListsRouter } from './routers/reading-lists.router';
import { recommendationsRouter } from './routers/recommendations.router';
import { searchRouter } from './routers/search.router';
import { sessionRouter } from './routers/session.router';
import { subscriptionRouter } from './routers/subscription.router';
import { userRouter } from './routers/user.router';

export const galateaWebRouter = c.router(
  {
    auth: authRouter,
    checkout: checkoutRouter,
    discovery: discoveryRouter,
    payment: paymentRouter,
    persist: persistRouter,
    progress: progressRouter,
    readingLists: readingListsRouter,
    recommendations: recommendationsRouter,
    search: searchRouter,
    session: sessionRouter,
    subscription: subscriptionRouter,
    track: getTrackRouter(c),
    user: userRouter,
  },
  { pathPrefix: '/api', strictStatusCodes: true },
);
